import { all } from "redux-saga/effects";
import { combineReducers } from "redux";
import * as auth from "app/modules/Auth/_redux/authRedux";
import storage from "redux-persist/lib/storage";
import persistReducer from "redux-persist/es/persistReducer";
import { providerNoteSlice } from "app/modules/ProviderNote/_redux/providerNoteSlice";
import { medicationSlice } from "app/modules/ProviderNote/_redux/medicationsSlice";
import { labOrderSlice } from "app/modules/ProviderNote/_redux/labOrderSlice";
import { userPermissionsSlice } from "app/modules/ProviderNote/_redux/userPermissionsSlice";
import { labResultSlice } from "app/modules/ProviderNote/_redux/labResultSlice";
import { patientsSlice } from "app/modules/Patients/_redux/patientSlice";
import { problemApi } from "app/redux/problemsService";
import { utilitiesApi } from "app/redux/utilityService";
import { medicationApi } from "app/redux/medicationService";
import { baseApi } from "redux/baseAPI";
import { patientApi } from "app/redux/patientService";
import { documentApi } from "app/redux/documentService";
import { pharmacyApi } from "app/redux/pharmacyService";
import { guidelinesApi } from "app/redux/guidelinesService";
import { referralSlice } from "app/modules/ProviderNote/_redux/referralasSlice";
import { physicalExamApi } from "app/redux/physicalExamService";
import { evaluationApi } from "app/redux/prescriberEvaluationService";
import { sdohApi } from "app/redux/sdohService";

const rootPersistConfig = {
  key: "root",
  storage: storage,
  whitelist: [""],
};

const reducers = combineReducers({
  auth: auth.reducer,
  providerNote: providerNoteSlice.reducer,
  patients: patientsSlice.reducer,
  medications: medicationSlice.reducer,
  referral: referralSlice.reducer,
  labOrder: labOrderSlice.reducer,
  userPermissions: userPermissionsSlice.reducer,
  labResult: labResultSlice.reducer,
  [problemApi.reducerPath]: problemApi.reducer,
  [utilitiesApi.reducerPath]: utilitiesApi.reducer,
  [medicationApi.reducerPath]: medicationApi.reducer,
  [baseApi.reducerPath]: baseApi.reducer,
  [patientApi.reducerPath]: patientApi.reducer,
  [pharmacyApi.reducerPath]: pharmacyApi.reducer,
  [documentApi.reducerPath]: documentApi.reducer,
  [guidelinesApi.reducerPath]: guidelinesApi.reducer,
  [physicalExamApi.reducerPath]: physicalExamApi.reducer,
  [sdohApi.reducerPath]: sdohApi.reducer,
  [evaluationApi.reducerPath]: evaluationApi.reducer,
});

export const rootReducer = persistReducer(rootPersistConfig, reducers);

export function* rootSaga() {
  yield all([auth.saga()]);
}
